import type { SectionKey } from "@features/dashboard/model/types";
import styles from "./SectionTabs.module.css";

const SECTION_TABS: Array<{ key: SectionKey; label: string }> = [
  { key: "overview", label: "Overview" },
  { key: "analysis", label: "Analysis" },
  { key: "charts", label: "Charts" },
  { key: "weapons", label: "Weapons" },
  { key: "matches", label: "Matches" },
];

export function SectionTabs({
  active,
  newCount,
  onChange,
}: {
  active: SectionKey;
  newCount: number;
  onChange: (section: SectionKey) => void;
}) {
  return (
    <nav className={styles.tabs} role="tablist" aria-label="Dashboard sections">
      {SECTION_TABS.map((tab) => (
        <button
          key={tab.key}
          id={`section-tab-${tab.key}`}
          type="button"
          role="tab"
          aria-selected={active === tab.key}
          aria-controls={`section-panel-${tab.key}`}
          className={[styles.tab, active === tab.key ? styles.tabActive : ""].filter(Boolean).join(" ")}
          onClick={() => onChange(tab.key)}
        >
          <span className={styles.label}>{tab.label}</span>
          {tab.key === "matches" && newCount > 0 && <em className={styles.badge} aria-label={`${newCount} new`}>{newCount}</em>}
        </button>
      ))}
    </nav>
  );
}
